import styled from 'styled-components';
import { theme } from '../../../theme';
export const Row = styled.tr.withConfig({ displayName: "vui--Row", componentId: "vui--1cif9m3" }) `display:contents;${({ selected }) => selected &&
    `
    &&&& > td {
      background-color: ${theme.colors.brand.blue.lightest};
    }
  `};${({ accentColor }) => accentColor &&
    `
    &> *:first-child {
      position: relative;
    }

    & > *:first-child::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      width: 4px;
      background-color: ${accentColor};
    }
  `}`;
//# sourceMappingURL=Row.js.map